import React, { lazy, Suspense, useEffect, useState } from "react";
import "./home.css";
import { Helmet } from "react-helmet-async";
import Loader from "../../components/loader/Loader";
import { PROJECT_NAME_SEO } from "../../Constant/Global";
import AOS from "aos";
import "aos/dist/aos.css";
import VideoBg from "./videoBg/VideoBg";
import ProductGrid from "./productGrid/ProductGrid";
import AboutSke from "../../components/skeleton/aboutSke/AboutSke";
import ContactModal from "../../components/contactModal/ContactModal";
// import VisionMission from "../about/visionMission/VisionMission";
// import Testimonials from "../../components/sliders/testimonials/Testimonials";
// import MeetsReliability from "../../components/MeetsReliability/MeetsReliability";
// import Blogs from "../../components/Blogs/Blogs";
// lazy loading
// const VideoBg = lazy(() => import("./videoBg/VideoBg"));
// const HomeHeroSec = lazy(() => import("./home-hero-sec/HomeHeroSec"));
const HomeAboutUs = lazy(() => import("./homeAboutUs/HomeAboutUs"));
// const ProductSlider = lazy(() => import("./productSlider/ProductSlider"));
// const Introduction = lazy(() => import("./homeIntro/Introduction"));
const PartnersLogo = lazy(() =>
  import("../../components/partnersLogo/PartnersLogo")
);
const Home = () => {
  const [open, setOpen] = useState(true);

  useEffect(() => {
    const isDesktop = window.innerWidth >= 768; // Define desktop breakpoint

    if (isDesktop) {
      AOS.init({
        duration: 1500, // Animation duration
        once: true, // Trigger animations only once
        mirror: false, // No repeating on scroll up
        offset: 0, // Offset for animations
      });

      AOS.refresh();
    } else {
      // Clean up AOS animations on mobile
      const animatedElements = document.querySelectorAll("[data-aos]");
      animatedElements.forEach((element) => {
        element.classList.remove("aos-animate");
        element.removeAttribute("data-aos"); // Disable AOS attributes on mobile
      });
    }
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpen(true);
    }, 10000); // 5 seconds

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Helmet prioritizeSeoTags>
        <title>{PROJECT_NAME_SEO}</title>
      </Helmet>
      <div className="home_main">
        {/* home video  */}
        <VideoBg />
        <Suspense fallback={<AboutSke />}>
          <HomeAboutUs />
        </Suspense>
        <Suspense fallback={<AboutSke />}>
          <ProductGrid />
        </Suspense>
        <Suspense fallback={<AboutSke />}>
          <section className="partners">
            <PartnersLogo />
          </section>
        </Suspense>
        {/* <HomeHeroSec /> */}
        {/* introduction */}
        {/* <Introduction /> */}
        {/* <MeetsReliability /> */}
        {/* <VisionMission /> */}
        {/* product slider  */}
        {/* <ProductSlider /> */}
        {/* product slider  */}
        {/* <Blogs />
          <Testimonials /> */}
        {/* home video  */}
      </div>
      {/* <ContactModal isOpen={open} onClose={() => setOpen(false)} /> */}
    </>
  );
};

export default Home;
